import React from "react"
import PropTypes from "prop-types"
import exact from "prop-types-exact"
import { Link } from "react-router-dom"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import { CloudinaryImage } from "@cloudinary/url-gen"
import { AdvancedImage } from "@cloudinary/react"
import { fill } from "@cloudinary/url-gen/actions/resize"
import { focusOn } from "@cloudinary/url-gen/qualifiers/gravity"
import { face } from "@cloudinary/url-gen/qualifiers/focusOn"
import { cloudinaryIdFromUrl } from "@coast/utils"

import InstructorCardBadges from "./InstructorCardBadges"
import { lazyLoadPreset } from "../../../utils/cloudinaryImageUtils"

// A card to display a Coastline team member.

const TeamCard = ({ image, name, text, link, instructorId, style }) => (
  <Card className="team-card" style={{ maxWidth: 400, ...style }} elevation={1}>
    {image ? (
      <div className="image-wrapper">
        <AdvancedImage
          cldImg={new CloudinaryImage(cloudinaryIdFromUrl(image), {
            cloudName: "coastline-academy",
          })
            .resize(fill(400, 400).gravity(focusOn(face())))
            .quality(80)
            .format("auto")}
          plugins={[lazyLoadPreset]}
          width={400}
          height={400}
        />
      </div>
    ) : null}
    <CardContent>
      <h3>{link ? <Link to={link}>{name}</Link> : name}</h3>
      <p>
        {text}
        {link && (
          <span>
            {" "}
            <Link to={link}>Read more...</Link>
          </span>
        )}
      </p>
      <InstructorCardBadges instructorId={instructorId} />
    </CardContent>
  </Card>
)

TeamCard.propTypes = exact({
  image: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  text: PropTypes.string,
  link: PropTypes.string,
  instructorId: PropTypes.string.isRequired,
  style: PropTypes.object,
})

TeamCard.defaultProps = {
  link: null,
  style: null,
  text: null,
}

export default TeamCard
